<template>
    <div>
        <form class="max-w-xs mx-auto" ref="form" @submit.prevent="addEmail">
            <div class="form-group mb-3">
                <input
                    :class="{'auth-input': true, 'is-invalid': errors.has('email')}"
                    :disabled="isLoggedIn()"
                    v-validate="'required'"
                    name="email"
                    placeholder="Email"
                    v-model="email"
                    type="email">
                <div class="invalid-feedback">
                    <span v-if="errors.has('email')" class="has-error text-center">{{ errors.first('email') }}</span>
                </div>
                <div class="form-group mb-5">
                    <button class="auth-input button button-success" :disabled="!readyToAddEmail" >{{ translate('auth_add_email') }}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import UserService from '@/lib/user.js'
import helperMixins from '@/mixins/helper.js'

export default {
    name: "AddEmailForm",

    mixins: [
        helperMixins
    ],

    data () {
        return {
            email: ''
        }
    },

    computed: {
        readyToAddEmail () {
            return this.email.length > 0
        }
    },

    methods: {
        addEmail () {
            this.$emit('add-email-success', this.email)
        },

        isLoggedIn () {
            const userService = new UserService

            return userService.isLoggedIn()
        }
    },
}
</script>
